/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DeleteMyLibraryPeopleRequestViewModel } from "../types/DeleteMyLibraryPeopleRequestViewModel.ts";

export const deleteMyLibraryPeopleRequestViewModelSchema = z.object({
  personIds: z
    .array(z.number().int())
    .describe(
      "IDs das pessoas a remover. Obrigatório informar ao menos uma pessoa.",
    )
    .nullish(),
}) as unknown as ToZod<DeleteMyLibraryPeopleRequestViewModel>;
